import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105c1c89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "as-labeled-block" }
const _hoisted_2 = {
  key: 0,
  class: "labeled-block-header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.header), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}